import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/** A single survey answer — scale (number), Yes/No (boolean) or free text. */
export type FeedbackAnswer = number | boolean | string;

/** Flat map of question id → answer — must match the backend RATING_QUESTIONS. */
export type FeedbackRatings = Record<string, FeedbackAnswer>;

/** What the rating modal collects before POSTing as JSON. */
export interface FeedbackRatingPayload {
  ratings: FeedbackRatings;
  comment: string;
}

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private readonly url = `${environment.apiBaseUrl}/feedback`;

  constructor(private http: HttpClient) {}

  /**
   * Submits the CSAT rating survey as JSON. The Bearer token (user email) is
   * attached automatically by AuthInterceptor; userName/email are derived by
   * the backend from the session, not trusted from the body. The page URL is
   * sent as a future-proofing hint.
   */
  submit(payload: FeedbackRatingPayload): Observable<unknown> {
    return this.http.post(this.url, {
      ratings: payload.ratings,
      comment: payload.comment,
      url:     window.location.href,
    });
  }
}
